import { render, staticRenderFns } from "./SettingTable.vue?vue&type=template&id=dd4e786e&scoped=true&"
import script from "./SettingTable.vue?vue&type=script&lang=js&"
export * from "./SettingTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingTable.vue?vue&type=style&index=0&id=dd4e786e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4e786e",
  null
  
)

export default component.exports